import React from 'react';
import styles from './styles.module.scss';

const ContactItem = ({
                       contactID,
                       firstName,
                       lastName,
                       phone,
                       email
                     }) => {
  return (
    <div key={contactID} className={styles.contactItem}>
      <span className={styles.fullName}>{[firstName, lastName].filter(Boolean).join(' ')}</span>
      <span>{phone}</span>
      <span>{email}</span>
    </div>
  );
};

export default ContactItem;